import './index.css'

import 'react-loading-skeleton/dist/skeleton.css'

import * as amplitude from '@amplitude/analytics-browser'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { fas } from '@fortawesome/free-solid-svg-icons'
import * as Sentry from '@sentry/react'
import { sentryDefaultConfiguration } from '@utils/frontend'
import axios, { type AxiosError, type InternalAxiosRequestConfig } from 'axios'
import * as React from 'react'
import * as ReactDOM from 'react-dom/client'
import { TgglClient, TgglProvider } from 'react-tggl-client'

import App from './App'
import env from './environments'
import reportWebVitals from './reportWebVitals'
import { authenticate } from './utils/auth'

/**
 * AXIOS CONFIG
 */
axios.defaults.withCredentials = true

axios.interceptors.response.use(response => response, async (error: AxiosError) => {
	const originalRequest = error.config as InternalAxiosRequestConfig & {_retry?: boolean | undefined} | undefined

	if (error?.response?.status === 401 && originalRequest && !originalRequest._retry) {
		const chatbotId = window.location.pathname.split('/')?.[1]

		const { accessToken } = await authenticate(chatbotId)

		originalRequest.headers.Authorization = `Bearer ${accessToken}`

		originalRequest._retry = true

		return axios(originalRequest)
	}

	throw error
})

/**
 * TGGL CONFIG
 */

const client = new TgglClient('AQLtdxxn_X4uv-Lww9Fj1b9zkNz0imB6QhHA6S2eRQs')

/**
 * SENTRY CONFIG
 */

Sentry.init({
	enabled: env.appEnv === 'production',
	environment: env.appEnv,
	dsn: env.sentryDsn,
	...sentryDefaultConfiguration
})

/**
 * FONT AWESOME CONFIG
 */
library.add(fas, fab)

const root = ReactDOM.createRoot(document.getElementById('root')!)

root.render(<React.StrictMode>
	<TgglProvider client={ client }>
		<App />
	</TgglProvider>
</React.StrictMode>)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
amplitude.init('a13fd1e83199bf7d3222566ae2a10ace', undefined, {
	defaultTracking:
	{
		sessions: true, pageViews: true, formInteractions: true, fileDownloads: true
	}
})

